import { IOrdersSettings } from '@epicuro-next/models/order-book';
import { EnvironmentSettings } from '@epicuro-next/platform/environment';

export function getOrderSettings(
  environmentSettings: EnvironmentSettings,
): IOrdersSettings | null {
  let config: IOrdersSettings | null = null;

  if (environmentSettings.ordersSettings) {
    try {
      config = JSON.parse(environmentSettings.ordersSettings);
    } catch (exception) {
      console.warn('Could not parse the configuration for orders settings', {
        exception,
        config: environmentSettings.ordersSettings,
      });
    }
  }

  if (!config?.cdnUrl) {
    config = {
      ...(config ?? {}),
      cdnUrl: environmentSettings.cdnUrl.replace(/\/$/, ''),
    };
  }
  return config;
}
